module.exports = __webpack_public_path__ + "img/curso.508e98b2.jpg";